export default __webpack_public_path__ + "static/media/cross.7d8ff3e3.svg";